<template>
    <div class="page page--artical layout">
        <!-- <div class="layout__header layout__header--artical">
        </div> -->
        <div class="layout__body" v-show="!isDelete">
			<div class="artical">
                <h3 class="artical__title">
                    {{artical.title}}
                </h3>
                <div class="artical__content artical_rich_content" v-html="artical.richContent"></div>
            </div>
			<div class="artical__action">
				<span>阅读&nbsp;{{artical.look_num}}&nbsp;</span>
				<span><a href="javascript:void(0);" :class="'artical__like ' + (artical.like ? 'active' : '')" @click="like($event, artical)"></a>&nbsp;{{artical.like_num}}</span>
			</div>
        </div>
		<div class="layout__body" v-show="isDelete">
			<div class="artical__del--icon"></div>
			<div class="artical__del--txt">图文已被删除</div>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src
import API from '@/api.js';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);
export default {
	name: 'home',
	data () {
		return {
			isDelete: false, // 图文是否已被删除
			id: this.$route.params.id, // 文章id
			source: this.$route.params.source, // 文章访问来源
			startTimeStamp: new Date(),
			endTimeStamp: new Date(),
			artical: {} // 文章内容
		};
	},
	methods: {
		getArtical () {
			let _self = this;
			API.getMsgInfo(_self.id).then((res) => {
				console.log('Artical: id=', _self.id, ', res=', res);
				// 图文存在
				if (res.status === 200) {
					_self.artical = res.data;
				} else {
					// 图文被删除
					this.isDelete = true;
				}
				console.log('richContent: ', _self.artical.richContent);
			});
		},
		like (e, artical) {
			API.like(artical.id).then((res) => {
				this.$msgBox.showMsgBox({
					title: '提示信息',
					desc: res.data.message
				});
				if (res.data.code === 200) {
					artical.like_num++;
				}
			});
		},
		setWechat () {
			let self = this;
			API.getWechatAssign().then((res) => {
				let data = res.data.data;
				self.$wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature, // 必填，签名，见附录1
					jsApiList: ['hideOptionMenu', 'showOptionMenu']
				});
				self.$wx.ready(function () {
					self.$wx.hideOptionMenu();
				});
				self.$wx.error(function () {
				});
				self.$wx.hideOptionMenu();
			});
		}
	},
	created () {
	},
	mounted () {
		this.getArtical();
		this.startTimeStamp = new Date().getTime();
		window.onbeforeunload = function () {
			this.endTimeStamp = new Date().getTime();
		};
		this.setWechat();
		this.$wx.hideOptionMenu();
	},
	beforeDestroy () {
		this.endTimeStamp = new Date();
		let duraFormat = '';
		let duraS = dayjs(this.endTimeStamp).diff(dayjs(this.startTimeStamp), 'seconds');
		let d = Math.floor(duraS / 60 / 60 / 24); // 天数
		let h = Math.floor((duraS - d * 24 * 3600) / 60 / 60); // 小时
		let m = Math.floor((duraS - d * 24 * 3600 - h * 3600) / 60); // 分钟
		m = (m < 10) ? ('0' + m) : m;
		let s = ((duraS - d * 24 * 3600 - h * 3600) % 60 < 10) ? ('0' + (duraS - d * 24 * 3600 - h * 3600) % 60) : ((duraS - d * 24 * 3600 - h * 3600) % 60);
		d = (d < 1) ? '' : d;
		h = (h < 1) ? '00' : (h < 10) ? ('0' + h) : (h);
		duraFormat = `${h}:${m}:${s}`;
		API.duration({ id: this.artical.id, duration: duraFormat });
	}
};
</script>

<style>
.artical_rich_content video {
	max-width: 100%;
}

.artical_rich_content img {
	max-width: 100%;
}
</style>
